import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IClientMessages } from '../../models/atendimento-socket-models/atendimento-socket-models';
import { MessagesStateService } from '../messages-state/messages-state.service';

@Injectable({
	providedIn: 'root',
})
export class MessageHandleService {
	private openedMessage$ = new BehaviorSubject<IClientMessages | undefined>(undefined);

	constructor(
		private readonly messagesStateService: MessagesStateService,
	) { }

	setOpenedMessage(clientMessage: IClientMessages): void {
		this.openedMessage$.next(clientMessage);
	}

	closeMessage(): void {
		this.messagesStateService.backToList();
		this.openedMessage$.next(undefined);
	}

	get openedMessage$$(): Observable<IClientMessages | undefined> {
		return this.openedMessage$.asObservable();
	}

	get openedMessage(): IClientMessages | undefined {
		return this.openedMessage$.value;
	}
}
